import React from "react"

import { StyledListItem, StyledSubListItem } from "./styles"
import { Card, useTheme } from "@mui/material"
import { ListImageItemTypes } from "../types"
import Image from "components/Image"

const ListImageItem: React.FC<ListImageItemTypes> = (props) => {
  const { subItems, hasBorder } = props
  const theme = useTheme()

  return (
    <>
      <StyledListItem
        borderBottom={hasBorder ? `2px solid ${theme.palette.grey.A400}` : ""}
        theme={theme}
      >
        {subItems.map((item) => (
          <StyledSubListItem
            justifyContent={"center"}
            key={item.content}
            theme={theme}
          >
            <Card>
              <Image size={"100"} image={item.content} />
            </Card>
          </StyledSubListItem>
        ))}
      </StyledListItem>
    </>
  )
}

export default ListImageItem
